import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, throwError, tap, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  token: any;
  tokenChanges: Subject<any> = new Subject<any>();

  public login(email: string, password: string) {
    return this.http.post(`${environment.apiUrlTemp}/auth/login`, { email, password }).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
      tap((res: any) => {
        return res;
      })
    );
  }

  public loginToken(token: string) {
    return this.http.post(`${environment.apiUrl}/login`, { token }).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
      tap((res: any) => {
        return res;
      })
    );
  }

  public getToken() {
    return localStorage.getItem('token');
    return this.token;
  }

  public logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('company_id');
    localStorage.removeItem('chatId');
    window.location.href = '/login';
  }

  public isAuthenticated() {
    return !!localStorage.getItem('token');
    return (!!localStorage.getItem('token') || !!this.token);
    // return !!this.token;
  }

  public setToken(token: string) {
    this.token = token;
    this.tokenChanges.next(token);
  }
}
